
const HeroSection = () => {
  return (
    <section className="relative bg-gradient-to-br from-slate-900 to-slate-800 text-white py-24">
      <div 
        className="absolute inset-0 bg-cover bg-center opacity-20"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/d15762f917566db9cddd80d40e55db1d.jpg')`
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <h1 className="text-5xl font-bold mb-6">
            Complete Global Expansion
            <span className="text-teal-400"> Services</span>
          </h1>
          <p className="text-xl text-gray-300 mb-8 leading-relaxed">
            From strategy to execution, we provide everything you need to successfully 
            expand your e-commerce business to international markets.
          </p>
          <button className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap">
            Book Your Free Strategy Call
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
